import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, } from '@angular/router';
import { LoginComponent } from './component/account/login/login.component';
import { ResetPasswordComponent } from './component/account/login/reset-password/reset-password.component';
import { CorpRoutes } from './corp/corp.routes';
import { HomeComponent } from './corp/home/home.component';
import { SqueletteComponent } from './component/squelette/squelette.component';
import { PricingMaskFillerComponent } from './component/saved-forms/pricing-mask/pricing-mask-filler.component';
import { UserAuthGuardService } from './services/user-auth-guard.service';
import { dockManagement } from './component/dock-management/dock-management.component';
import { DashboardComponent } from "./component/dashboard/dashboard.component";

export const APP_ROUTES: Routes = [
  ...CorpRoutes,
  { path: '', redirectTo: '/accueil', pathMatch: 'full' },
  { path: 'accueil', component: HomeComponent, canActivate: [UserAuthGuardService] },
  { path: "app/dashboard", component: DashboardComponent },
  { path: "login", component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: "inscription", loadChildren: 'app/component/account/inscription/inscription.module#InscriptionModule' },
  { path: "app/user", loadChildren: 'app/component/user/user.module#UserModule' },
  { path: "app/pricing", loadChildren: 'app/component/pricing-booking/pricing/pricing.module#PricingModule' },
  { path: "app/pricing/responsive", loadChildren: 'app/component/pricing-booking-responsive/pricing/pricing.module#PricingResponsiveModule' },
  { path: "app/transport-management", loadChildren: 'app/component/pricing-booking/transport-management/transport-management.module#TransportManagementgModule' },
  { path: "app/quality-management", loadChildren: 'app/component/quality-management/quality-management.module#QualityManagementModule' },
  { path: "app/compliance-matrix", loadChildren: 'app/component/compliance-matrix/compliance-matrix.module#ComplianceMatrixModule' },
  { path: "app/freight-audit", loadChildren: 'app/component/freight-audit/freight-audit.module#FreightAuditModule' },
  { path: "app/track-trace", loadChildren: 'app/component/track-trace/track-trace.module#TrackTraceModule' },
  { path: "app/dock-management", loadChildren: 'app/component/dock-management/dock-management.module#dockManagementModule' },
  { path: "squelette", loadChildren: 'app/component/squelette/squelette.module#SqueletteModule' },
  { path: "formsearch", component: PricingMaskFillerComponent },
  { path: '**', redirectTo: '/accueil', pathMatch: 'full' },
];

export const appRouter: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES, {
  preloadingStrategy: PreloadAllModules
});



// WEBPACK FOOTER //
// ./src/app/app.routes.ts